import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { faqs } from '../../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-16 md:py-24" data-id="element-13" data-mp="2z2p7r103dhud">
      <div className="mx-auto max-w-3xl px-5 md:px-8" data-id="element-14" data-mp="2z3h268hyd9j2">
        <Reveal data-id="element-15" data-mp="3msjgp7haim9c">
          <h2 className="font-display text-2xl font-black leading-tight text-ink sm:text-3xl md:text-[2.5rem]" data-id="element-16" data-mp="3mu4dl3r2uhad">
            PREGUNTAS FRECUENTES
          </h2>
        </Reveal>

        <dl className="mt-8 space-y-3" data-id="element-17" data-mp="3d3ruzh2toy6v">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <Reveal key={faq.question} delay={index * 0.03} data-id="element-18" data-mp="3i005gh62s37p" data-mpi={index}>
                <div className="overflow-hidden rounded-xl border border-cream-line bg-cream" data-id="element-19" data-mp="9l8a4zmh4um3">
                  <dt data-id="element-20" data-mp="ee1f9oluu4yp">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 hover:bg-cream-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-wood" data-id="element-21" data-mp="eekq6ld37t38">
                      <span className="font-display text-sm font-bold uppercase leading-snug text-ink md:text-base" data-id="element-22" data-mp="2jgeyiqq9osz5">
                        {faq.question}
                      </span>
                      <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-wood transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-23" data-mp="2tfxhb3ufy8pm" />
                    </button>
                  </dt>

                  <AnimatePresence initial={false} data-id="element-24" data-mp="z3h1bbbufg7k">
                    {isOpen && <motion.dd initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-25" data-mp="u44g0v0meh73">
                        <p className="border-t border-cream-line px-5 py-4 text-sm leading-relaxed text-ink/75 md:text-base" data-id="element-26" data-mp="22pt6x2sovsag">
                          {faq.answer}
                        </p>
                      </motion.dd>}
                  </AnimatePresence>
                </div>
              </Reveal>;
        })}
        </dl>
      </div>
    </section>;
}